import {useMemo} from "react";
import {
    EBirdChecklistByFamily,
    EBirdMyDataSchema,
    getChecklistByFamily,
    getFilteredObservations,
    getObservationsByLocation,
    getObservationsBySpecies
} from "ebird-mydata-reader";

export function useBirdData(rawData: any[]) {
    const lifeList = useMemo((): EBirdMyDataSchema[] => {
        return rawData.length ? getFilteredObservations(rawData, 'life') : [];
    }, [rawData]);

    const observationsBySpecies = useMemo(() => {
        return getObservationsBySpecies(rawData);
    }, [rawData]);

    const observationsByLocation = useMemo(() => {
        return getObservationsByLocation(rawData);
    }, [rawData]);

    const checklist = useMemo((): EBirdChecklistByFamily[] => {
        return observationsBySpecies.length ? getChecklistByFamily(observationsBySpecies) : [];
    }, [observationsBySpecies]);

    return {
        lifeList,
        observationsBySpecies,
        observationsByLocation,
        checklist
    }
}
